var React = require('react');
var { sanitize } = require('isomorphic-dompurify');
var ProgressBar = require('../../ProgressBar/progressBar.jsx');
var labels = require('MemberJoinLabels');

class UserAlreadyMember extends React.Component {
    constructor(props) {
        super(props);

        this.getCustomizedGreeting = this.getCustomizedGreeting.bind(this);
        this.getModalMarkup = this.getModalMarkup.bind(this);
        this.showInfoModal = this.showInfoModal.bind(this);
        this.dismissInfoModal = this.dismissInfoModal.bind(this);
    }

    componentDidMount() {
        this.showInfoModal();
    }

    showInfoModal() {
        $('#infoModal').modal('show');
        $('#infoModal').on('hidden.bs.modal', () => false);
    }

    dismissInfoModal() {
        window.location = window.location.origin;
        return;
    }

    getCustomizedGreeting() {
        // If the user has proforma, return only the basic greeting
        if (this.props.proforma === true) {
            if (this.props.fullName != null) {
                return (labels.userAlreadyMember.hi + ' ' + this.props.fullName);
            }

            else {
                return labels.userAlreadyMember.hi;
            }
        }

        // If the user has an active membership, display that information
        var memberRenewal = this.props.membershipType ? [labels.userAlreadyMember.alreadyAMember, this.props.membershipType + '.'].join(' ') : '';
        return labels.userAlreadyMember.hi + ' ' + this.props.fullName + memberRenewal;
    }

    getCustomizedBody() {
        // If the user has proforma, return different content configured in the Sitecore item
        if (this.props.proforma === true) {
            return labels.userHasProformaContent;
        }

        return labels.userAlreadyMemberContent;
    }

    getModalMarkup(id) {
        return <div className={"basemodal modal fade"} id={id} tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className={"modal-dialog modal-lg modal-dialog-centered"} role="document">
                <div className={"modal-content"}>
                    <div className={"modal-header"}>
                        <a href="#" className={"close"} data-dismiss="modal" aria-label="Close">
                            <img src="../../../../../Images/base/dist/icon-close.svg" alt="" />
                        </a>
                    </div>
                    <div className={"modal-body"}>
                        <h3>{this.getCustomizedGreeting()}</h3>
                        <p dangerouslySetInnerHTML={{ __html: this.getCustomizedBody() }}></p>
                    </div>
                    <div className={"modal-footer"}>

                    </div>
                </div>
            </div>
        </div>;
    }

    render() {
        const itemsYouNeed = sanitize(labels.itemsYouWillNeedContent);
        const stateComponentContent = sanitize(labels.stateComponentDuesContent);
        const bottomContent = sanitize(labels.bottomContent);

        const modal = this.getModalMarkup('infoModal');

        // I'm dropping some "fake" markup on here for background appearance, but really the only thing that's needed is the modal itself
        return <div className={"member-application "}>
            <h1>{labels.applicationTitle}</h1>
            <div className={"step-container"}>
                <p>{labels.introduction}</p>

                <div className={"accordionItem close"}>
                    <button type="button" className={"accordionItemHeading has-dropdown"}>{labels.itemsYouWillNeedTitle}</button>
                    <div className={"accordionItemContent"}>
                        <p dangerouslySetInnerHTML={{ __html: itemsYouNeed }}></p>
                    </div>
                </div>

                <div className={"accordionItem close"}>
                    <button type="button" className={"accordionItemHeading has-dropdown"}>{labels.stateComponentDuesTitle}</button>
                    <div className={"accordionItemContent"}>
                        <p dangerouslySetInnerHTML={{ __html: stateComponentContent }}></p>
                    </div>
                </div>

                <p dangerouslySetInnerHTML={{ __html: bottomContent }}></p>
            </div>
            {modal}
        </div>;
    }
}

module.exports = UserAlreadyMember;